import { useTranslation } from 'react-i18next';

import { FOR_INVESTORS_MAX_LENGTHS, FOR_INVESTORS_SECTIONS } from 'constants/businessToolSections/forInvestors';

import { FieldArrayComponent } from 'components/_basic/Form/FieldArray';
import { FormHeader } from 'components/_basic/FormHeader/FormHeader';
import { FormSectionCard } from 'components/_basic/FormSectionCard/FormSectionCard';
import { FORM_SECTION_CARD_VARIANT } from 'components/_basic/FormSectionCard/types';
import { StagesComponent } from 'components/BusinessToolForm/Sections/ImplementationPlan/components/StagesComponent';
import {
  IMPLEMENTATION_PLAN_NAMES,
  prefix,
  stagesInitialValues,
} from 'components/BusinessToolForm/Sections/ImplementationPlan/utils/form';

import { concatWithDot } from 'helpers/string';
export const ImplementationPlan: React.FC = () => {
  const { t } = useTranslation();

  const canAccess = true;

  return (
    <>
      <FormSectionCard variant={FORM_SECTION_CARD_VARIANT.LARGE}>
        <FormHeader
          title={t(`chapters.${FOR_INVESTORS_SECTIONS.COMPANY_AND_PROJECT}`)}
          badgeText={t('chapters.IMPLEMENTATION_PLAN')}
          locked={!canAccess}
        />
      </FormSectionCard>
      <FormSectionCard collapsible disabled={!canAccess} title={t('implementationPlan.stages.title')}>
        <FieldArrayComponent
          name={concatWithDot(prefix, IMPLEMENTATION_PLAN_NAMES.STAGES)}
          initialItem={stagesInitialValues}
          buttonText={t('implementationPlan.stages.stage')}
          disabled={!canAccess}
          maxLength={10}
        >
          {(namePrefix) => (
            <StagesComponent
              maxLength={FOR_INVESTORS_MAX_LENGTHS.IMPLEMENTATION_PLAN.STAGE}
              hiddenLabel={true}
              multiline={true}
              name={namePrefix}
              disabled={!canAccess}
            />
          )}
        </FieldArrayComponent>
      </FormSectionCard>
    </>
  );
};
